export const apiHost =
  process.env.NODE_ENV === "production"
    ? "https://ratifika.com.pe"
    : "https://ratifika.com.pe";

/* https://test.ratifika.com.pe*/
/* https://desarrollo.ratifika.com.pe */
/*https://ratifika.com.pe*/
/*http://localhost:3001*/
